import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

declare let $: any;

//let BannerURL = {header: "/aem/content/flysas-lu/en/_jcr_content/ipar-header.html", footer: "/aem/content/flysas-lu/en/_jcr_content/ipar-footer-content.html"};

//let host = location.origin.includes('localhost') || location.origin.includes('test') ? "https://test.flysas.com" : "https://www.flysas.com";

// $(function () {
//   if((location.origin.indexOf('test')> -1 || location.origin.indexOf('localhost') > -1)) {
//     loadBanners(`${host}${BannerURL.header}`,`${host}${BannerURL.footer}`);
//   } else {
//     loadBanners(`${host}${BannerURL.header}`,`${host}${BannerURL.footer}`);
//   }
// });

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));

// function loadBanners(header, footer) {
//   $("#sas-header-wrapper").load(header);
//   $("#sas-footer-wrapper").load(footer);
// }

// $(function () {
//  // const windowLocation = location.origin;
//  // windowLocation.indexOf('localhost') > -1 || windowLocation.indexOf('test') > -1
//    $("#sas-header-wrapper").load("https://www.flysas.com/aem/content/flysas-lu/en/_jcr_content/ipar-header.html")
//     $("#sas-footer-wrapper").load("https://www.flysas.com/aem/content/flysas-lu/en/_jcr_content/ipar-footer-content.html")
// });